export const SYSTEM_CONFIG_PREVIEW = "SYSTEM_CONFIG_PREVIEW"
export const SYSTEM_CONFIG_UPDATE = "SYSTEM_CONFIG_UPDATE"
export const SYSTEM_CONFIG_PROCESS_SUCCESS = "SYSTEM_CONFIG_PROCESS_SUCCESS"
export const SYSTEM_CONFIG_DATASOURCE_SUCCESS = "SYSTEM_CONFIG_DATASOURCE_SUCCESS"
export const SYSTEM_CONFIG_RESET = "SYSTEM_CONFIG_RESET"
export const SYSTEM_CONFIG_PROCESS_RESET = "SYSTEM_CONFIG_PROCESS_RESET"
export const SYSTEM_CONFIG_SYSTEM_DATE_SET = "SYSTEM_CONFIG_SYSTEM_DATE_SET"

export const SYSTEM_CONFIG_PREPARE_UPDATE = "SYSTEM_CONFIG_PREPARE_UPDATE"
export const SYSTEM_CONFIG_PREPARE_UPDATE_RESET = "SYSTEM_CONFIG_PREPARE_UPDATE_RESET"


export interface SystemConfigRequest {
    type: typeof SYSTEM_CONFIG_PREVIEW,
    payload?: any
}
export interface SystemConfigUpdate {
    type: typeof SYSTEM_CONFIG_UPDATE,
    payload?: any
}
export interface SystemConfigDataSouceSuccess {
    type: typeof SYSTEM_CONFIG_DATASOURCE_SUCCESS,
    payload: any
}
export interface SystemConfigProcessSuccess {
    type: typeof SYSTEM_CONFIG_PROCESS_SUCCESS,
    payload: any
}

export interface SystemConfigPrepareUpdate {
    type: typeof SYSTEM_CONFIG_PREPARE_UPDATE,
    payload: any
}

export interface SystemConfigPrepareUpdateReset {
    type: typeof SYSTEM_CONFIG_PREPARE_UPDATE_RESET
}

export interface SystemConfigSystemDateSet {
    type: typeof SYSTEM_CONFIG_SYSTEM_DATE_SET,
    payload: any
}

export interface SystemConfigProcessReset {
    type: typeof SYSTEM_CONFIG_PROCESS_RESET
}



export interface SystemConfigReset {
    type: typeof SYSTEM_CONFIG_RESET
}

export type SystemConfigAction =
    | SystemConfigRequest
    | SystemConfigUpdate
    | SystemConfigDataSouceSuccess
    | SystemConfigProcessSuccess
    | SystemConfigProcessReset
    | SystemConfigPrepareUpdate
    | SystemConfigPrepareUpdateReset
    | SystemConfigSystemDateSet
    | SystemConfigReset